<!--
 * @author yuping.pang
 * @date 2024-09-12 23:18
 * @description 收货计划拆分-弹窗
-->
<template>
  <a-modal
    ref="createModal"
    title="收货计划拆分"
    :width="960"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <h3><strong>拆分前信息：</strong></h3>
    <ls-info-form :splitNumber="3">
      <ls-info-item title="供应商" slot="factoryName">{{ selectedRecord.factoryName }}</ls-info-item>
      <ls-info-item title="计划单号" slot="billNo">{{ selectedRecord.billNo }}</ls-info-item>
      <ls-info-item title="增货计划单" slot="parentBillNo">{{ selectedRecord.parentBillNo }}</ls-info-item>
      <ls-info-item title="物料编码" slot="materialNo">{{ selectedRecord.materialNo }}</ls-info-item>
      <ls-info-item title="物料名称" slot="materialName" :IsContentTip="true" :value="selectedRecord.materialName"></ls-info-item>
      <ls-info-item title="物料描述" slot="materialSpec" IsContentTip :value="selectedRecord.materialSpec"></ls-info-item>
      <ls-info-item title="单据状态" slot="status">{{ RECEIPTS_STATUS[selectedRecord.status] || '' }}</ls-info-item>
      <ls-info-item title="要求到仓数量" slot="requireDeliveryQuantity">{{ selectedRecord.requireDeliveryQuantity }}</ls-info-item>
      <ls-info-item title="要求到货日期" slot="requireDeliveryDay">{{ selectedRecord.requireDeliveryDay }}</ls-info-item>
      <ls-info-item title="未安排数量" slot="unArrangeQuantity">{{ selectedRecord.unArrangeQuantity }}</ls-info-item>
    </ls-info-form>
    <div class="mt-8">
      <h3><strong>拆分后信息：</strong></h3>
      <div class="table-page-operator-wrapper">
        <a-button @click="addLine()" type="primary">新增行</a-button>
      </div>
      <a-table
        ref="modalTable"
        :columns="columns"
        :data-source="splitList"
        :pagination="false"
        row-key="indexId"
        :scroll="{ x: 880, y: 260 }"
      >
        <template slot="requireDeliveryQuantity" slot-scope="text, record">
          <a-input-number
            class="full-width"
            v-model="record.requireDeliveryQuantity"
            :min="1"
            :precision="0"
            placeholder="请输入"
          />
        </template>
        <template slot="requireDeliveryDay" slot-scope="text, record">
          <a-date-picker v-model="record.requireDeliveryDay" valueFormat="YYYY-MM-DD" />
        </template>
        <span slot="operation" slot-scope="text, record, index">
          <a @click="handleDelete(index)">删除</a>
        </span>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { RECEIPTS_STATUS } from '../enum';
import {
  apiGetPlanInfo, apiSaveSplitData
} from '@/services/module/receiving-plan';

export default {
  name: 'SplitModal',
  props: {
  },
  data () {
    this.RECEIPTS_STATUS = RECEIPTS_STATUS;
    return {
      confirmLoading: false,
      visible: false,
      selectedRecord: {},
      columns: [
        {
          title: '计划单号',
          dataIndex: 'billNo',
          ellipsis: true
        },
        {
          title: '要求到仓数量',
          dataIndex: 'requireDeliveryQuantity',
          width: '30%',
          scopedSlots: { customRender: 'requireDeliveryQuantity' }
        },
        {
          title: '要求到货日期',
          dataIndex: 'requireDeliveryDay',
          width: 200,
          scopedSlots: { customRender: 'requireDeliveryDay' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 100,
          scopedSlots: { customRender: 'operation' }
        }
      ],
      splitList: []
    }
  },
  methods: {
    // 删除
    handleDelete (index) {
      this.splitList.splice(index, 1);
    },
    async show (record) {
      const billNo = record.billNo;
      this.selectedRecord = {};
      try {
        this.$emit('changeLoading', true);
        const billDataRes = await apiGetPlanInfo({ billNo });
        if (billDataRes.code === 200) {
          this.selectedRecord = billDataRes.data;
          if(this.selectedRecord.unArrangeQuantity >= 2) {
            this.addLine()
            this.visible = true
          }else {
            this.$message.warn('该计划单不可拆分');
          }
        }
      }catch(e) {}finally{
        this.$emit('changeLoading', false);
      }
    },
    // 新增行
    addLine () {
      const obj = {
        billNo: this.selectedRecord.billNo + this.gitSubBillNo(),
        requireDeliveryQuantity: null,
        requireDeliveryDay: null,
        indexId: Math.random().toString().slice(2)
      }
      this.splitList.push(obj);
    },
    gitSubBillNo() {
      let subNo = this.splitList.length + 1;
      if(subNo < 10) {
        subNo = '0' + subNo;
      }
      return '-' + subNo;
    },
    // 关闭模态框
    close () {
      this.reset();
      this.visible = false
    },
    // 保存
    confirm () {
      if(this.splitList.length === 0) {
        this.$message.warn('至少添加一行数据');
        return;
      }
      let total = 0;
      for(const item of this.splitList) {
        if(!item.requireDeliveryDay || !item.requireDeliveryQuantity) {
          return this.$message.warn('存在行未完全填写');
        }
        total += item.requireDeliveryQuantity;
        if(total > Number(this.selectedRecord.unArrangeQuantity)) {
          return this.$message.warn('拆分数量不符');
        }
      }
      this.confirmLoading = true;
      this.$emit('changeLoading', true);
      apiSaveSplitData({
        ...this.selectedRecord,
        receiptPlanSplitDetailDTOList: this.splitList
      }).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 调用外部刷新列表方法
          this.$emit('successCall')
          this.close();
        } else {
          this.$message.error(response.msg)
        }
        this.confirmLoading = false;
        this.$emit('changeLoading', false);
      }).catch(e => {
      }).finally(() => {
        this.confirmLoading = false;
        this.$emit('changeLoading', false);
      })
    },
    // 表单重置
    reset () {
      this.splitList = [];
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-cascader-input{
  width: 240px;
}
/deep/.ant-modal-body{
  padding-top: 8px;
  height: 580px;
  overflow-y: scroll;
}
.mt-8 {
  margin-top: 8px;
}
.full-width {
  width: 100%;
}
</style>
